import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { AppConfigService } from './appConfigService';
import { CMSClient } from 'src/app/model/Client/NewClient';
import { CreateAssignmentRequestModel } from '../model/Workspace/CreateAssignmentRequestModel';
import { FinanceServiceResponseModel, CreateAssignmentResponseModel, AssignmentCodeStatusResponseModel, AssignmentCodeStatusRequestModel} from '../model/Workspace/FinanceServiceResponseModel';
import { AssignmentRequestList } from '../model/Workspace/AssignmentRequestList';
import { AssignmentResponse } from '../model/Workspace/AssignmentResponse';

@Injectable({
  providedIn: 'root'
})
export class CMSService {

  IntegrationAPIEndPoint: string;
  FinanceIntegrationAPIEndPoint: string;
  constructor(private environment: AppConfigService, private http: HttpClient) {
    this.IntegrationAPIEndPoint = environment.config.DATA.API_END_POINT.INTEGRATION_API_URL;
    this.FinanceIntegrationAPIEndPoint = environment.config.DATA.API_END_POINT.FINANCE_INTEGRATION_API_URL;
  }

  GetClientByNameFromCMS(searchTerm: string): Observable<CMSClient[]> {
    return this.http.get<CMSClient[]>(this.IntegrationAPIEndPoint + '/CMS/GetClientInformationByClientName/' + searchTerm);
  }
  PostPrimaryAssignment(list: AssignmentRequestList): Observable<AssignmentResponse[]> {
    return this.http.post<AssignmentResponse[]>(this.IntegrationAPIEndPoint + '/CMS/PrimaryAssignment', list);
  }
  PostPrimaryAssignmentFinance(list: CreateAssignmentRequestModel): Observable<FinanceServiceResponseModel<CreateAssignmentResponseModel>> {
    return this.http.post<FinanceServiceResponseModel<CreateAssignmentResponseModel>>(this.FinanceIntegrationAPIEndPoint + '/api/assignments/create', list);
  }
  PostCodeStatusFinance(assignmentCodeStatusRequestModel :AssignmentCodeStatusRequestModel): Observable<FinanceServiceResponseModel<AssignmentCodeStatusResponseModel>> {
    return this.http.post<FinanceServiceResponseModel<AssignmentCodeStatusResponseModel>>(this.FinanceIntegrationAPIEndPoint + '/api/assignments/codeStatus', assignmentCodeStatusRequestModel);
  }  
}
